import { Skull } from "@phosphor-icons/react";
import { useState } from "react";

import NavItem from "features/layout/components/NavItem";

import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import useAppStore from "common/hooks/useAppStore";

import MiscOptions from "./MiscOptions";
import RentedSubscriptionStatus from "./RentedSubscription";
import SubscriptionStatus from "./SubscriptionStatus";
import WorkspacePermissions from "./WorkspacePermissions";

export default function DebugPopup({ isExpanded }: { isExpanded: boolean }) {
  const [isOpen, setIsOpen] = useState(false);
  const workspacePermissions = useAppStore(
    (state) => state.debugOptions.workspacePermissions,
  );

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger>
        <NavItem
          isActive={isOpen}
          isExpanded={isExpanded}
          icon={<Skull weight="fill" />}
        >
          Debug menu
        </NavItem>
      </PopoverTrigger>
      <PopoverContent
        className="flex w-80 flex-col p-4"
        side="right"
        align="end"
      >
        <MiscOptions />
        <SubscriptionStatus />
        <RentedSubscriptionStatus />
        {workspacePermissions && <WorkspacePermissions />}
      </PopoverContent>
    </Popover>
  );
}
